import { toast } from 'react-toastify';

export const notify = {
  promise: async ({
    promise,
    success,
    pending,
    error
  }: {
    promise: Promise<unknown>;
    success: string;
    pending: string;
    error: string;
  }): Promise<unknown> =>
    toast.promise(
      promise,
      {
        success,
        pending,
        error
      }
    ),
  success: (message: string): number | string =>
    toast<string>(message, {
      position: 'top-right',
      autoClose: 2500,
      closeOnClick: true,
      theme: 'dark',
      type: 'success',
    }),
  info: (message: string): number | string =>
    toast<string>(message, {
      position: 'top-right',
      autoClose: 2500,
      closeOnClick: true,
      theme: 'dark',
      type: 'info',
    }),
  error: (message: string): number | string =>
    toast<string>(message, {
      position: 'top-right',
      autoClose: 5000,
      closeOnClick: true,
      theme: 'dark',
      type: 'error',
    }),
};
